import './modal-form.scss'
import { EventBus } from 'js/utility/event-bus.js'

export default {
    name: 'modal-form',

    data: {
        display: false,
        form: null
    },

    mounted () {
        EventBus.$on('ModalForm.toggle', form => {
            if (!this.display) {
                this.form = form
                this.toggleDisplay()
            }
        })

        const certificateButton = document.querySelector('.button--login-certificate')
        if (certificateButton) {
            certificateButton.addEventListener('click', () => EventBus.$emit('ModalForm.toggle', 'certificate'))
        }
    },

    methods: {
        toggleDisplay () {
            this.display = !this.display
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/modal-form/modal-form.js